import pagination from './pagination.vue';

pagination.install = function (app) {
  app.component(pagination.name, pagination)
}

export default pagination


//////////////////
// WEBPACK FOOTER
// ./packages/pagination/index.js
// module id = null
// module chunks = 